import request from '@/utils/request'
import Auth from '@/store/modules/auth'

export const exportUsers = function(role: string) {
  request.interceptors.request.use(
    (config) => {
      config.headers['content-type'] = 'blob'
      config.headers.Authorization = 'Bearer ' + Auth.state.token
      return config
    }
  )

  return request({
    url: '/statistics/roles.export?role=' + role,
    method: 'get'
  })
}

export const exportInvoice = function(params: any) {
  request.interceptors.request.use(
    (config) => {
      config.headers['content-type'] = 'blob'
      config.headers.Authorization = 'Bearer ' + Auth.state.token
      return config
    }
  )

  return request({
    url: '/statistics/invoice.export',
    method: 'get',
    responseType: 'blob',
    params
  })
}
